import { loadingSpinnerActions } from "../../actions/loadingSpinnerActions";
var ProductLinesReduxProps = {
    mapDispatchToProps: function (dispatch) {
        return {
            onShowSpinner: function () { return dispatch({ type: loadingSpinnerActions.SHOW_SPINNER_MODAL }); },
            onHideSpinner: function () { return dispatch({ type: loadingSpinnerActions.HIDE_SPINNER_MODAL }); },
        };
    }
};
export default ProductLinesReduxProps;



//////////////////
// WEBPACK FOOTER
// ./src/views/SpecialOffers/SpecialOffersReduxProps.ts
// module id = 472
// module chunks = 0